<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ keno_title }}
      td
        PTSelect(
          ref="keno_upline_pt"
          :dirty="$v.keno_upline_pt.$dirty"
          :error="$v.keno_upline_pt.$error"
          :options="keno_upline_options"
          :value="keno_upline_pt"
          @input="input_keno_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="keno_account_pt"
          :dirty="$v.keno_account_pt.$dirty"
          :error="$v.keno_account_pt.$error"
          :options="keno_account_options"
          :value="keno_account_pt"
          @input="input_keno_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="keno_upline_remaining"
          :dirty="$v.keno_upline_remaining.$dirty"
          :error="$v.keno_upline_remaining.$error"
          :options="keno_account_options"
          :value="keno_upline_remaining"
          @input="$v.keno_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="keno_account_min"
          :dirty="$v.keno_account_min.$dirty"
          :error="$v.keno_account_min.$error"
          :options="keno_min_options"
          :value="keno_account_min"
          @input="$v.keno_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      keno_upline_pt: 0,
      keno_account_pt: 0,
      keno_upline_remaining: 0,
      keno_account_min: 0
    }
  },
  validations() {
    return {
      keno_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('KN')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.keno_account_pt
            }
            if(total < this.keno_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      keno_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('KN')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.keno_upline_pt
              if(total < this.keno_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      keno_upline_remaining: {
        required
      },
      keno_account_min: {
        required
      }
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    keno_title: function () {
      return this.$t("ui.keno") + " (" + this.keno_upline_min + "%-" + this.keno_upline_max + "%)"
    },
    keno_upline_min: function() {
      return this.$store.getters.getPTKN[0].account_min
    },
    keno_upline_max: function() {
      return this.$store.getters.getPTKN[0].account_pt
    },
    keno_account_max: function() {
      return this.keno_upline_max - this.keno_upline_pt
    },
    keno_upline_options: function() {
      return this.$helpers.getPTRateList(this.keno_upline_max)
    },
    keno_account_options: function() {
      return this.$helpers.getPTRateList(this.keno_account_max)
    },
    keno_min_options: function() {
      return this.$helpers.getPTRateList(this.keno_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.keno_upline_pt.$model = this.keno_upline_max
    }
    if(!this.$helpers.isPlatformEnabled('KN')) {
      this.$v.keno_upline_pt.$model = this.keno_upline_min
    }
  },
  methods: {
    input_keno_upline_pt(e) {
      this.$v.keno_upline_pt.$model = e
      this.$v.keno_account_pt.$model = this.keno_account_max

      if (this.keno_upline_remaining > this.keno_account_max) {
        this.$v.keno_upline_remaining.$model = 0
      }
      if (this.keno_account_min > this.keno_account_pt) {
        this.$v.keno_account_min.$model = 0
      }
    },
    input_keno_account_pt(e) {
      this.$v.keno_account_pt.$model = e
      if (this.keno_account_min > this.keno_account_pt) {
        this.$v.keno_account_min.$model = 0
      }
    }
  }
}

</script>